import { metadata } from 'lib_ui-services';

const _p = {
    getMinimumForeignKeyFieldsFromDictionary: metadata.getMinimumForeignKeyFieldsFromDictionary,
    getRelationMetadata: metadata.getRelationMetadata
};
export const _private = _p;

export default async function getLocationInfo(roomLocation, dispatch) {
    let newLocation;
    // If the Id was passed in as a string, look up the room, otherwise
    // It should already be a room location object.
    if (typeof roomLocation === 'string') {
        const newLocationResp = await dispatch(
            {
                criteria: { _id: roomLocation }
            },
            { verb: 'get', namespace: 'location', relation: 'location', type: 'find' },
            true
        );
        newLocation = newLocationResp.result[0];
    } else if (typeof roomLocation === 'object' && roomLocation._id != null) {
        newLocation = roomLocation;
    } else {
        throw new Error('Unexpected type passed into the roomLocation parameter for getLocationInfo.');
    }

    const locationInfo = {
        'location:location': await _p.getMinimumForeignKeyFieldsFromDictionary(
            newLocation,
            'item',
            'item',
            'location',
            'location'
        )
    };

    // If no building is specified on the newLocation param, just return now.
    if (!newLocation['location:building']) return locationInfo;

    // We should already have the location building foreign key from the location record
    locationInfo['location:building'] = newLocation['location:building'];

    // Some use cases (e.g. PALM) don't model the building/company hierarchy.
    // If the building relation isn't part of this use case's metadata, skip the
    // company dispatch to avoid "Cannot find relation: location_building".
    if (!_p.getRelationMetadata('location', 'building', false)) return locationInfo;

    // Get the company foreign key from the stored building record
    const buildingResp = await dispatch(
        {
            criteria: { _id: locationInfo['location:building']._id }
        },
        { verb: 'get', namespace: 'location', relation: 'building', type: 'find' },
        true
    );
    // The building record may not exist locally. Assign undefined in that case so a
    // spread merge over an existing record clears any stale company rather than keeping it.
    const company = buildingResp?.result?.[0]?.['location:company'];
    locationInfo['location:company'] = company;

    return locationInfo;
}
